import { normalizeUnit } from '../units/normalize.js';
/**
 * Convert a reviewed RecipeDraft into the write input used by the recipes API.
 * Groups become sections; unknown unit strings are kept as unitText.
 */
export function draftToRecipeInput(draft, options = {}) {
    const ingredientGroups = new Map();
    for (const ing of draft.ingredients) {
        const unit = normalizeUnit(ing.unit);
        const key = ing.group ?? null;
        const list = ingredientGroups.get(key) ?? [];
        list.push({
            quantity: ing.quantity,
            quantityMax: ing.quantityMax,
            quantityText: ing.quantityText,
            unitCode: unit?.code ?? null,
            unitText: unit ? null : (ing.unit ?? null),
            name: ing.name,
            note: ing.note,
            optional: ing.optional,
            scalable: ing.scalable && (unit ? unit.scalableByDefault : ing.quantity !== null),
            originalText: ing.originalText,
        });
        ingredientGroups.set(key, list);
    }
    const stepGroups = new Map();
    for (const step of draft.steps) {
        const key = step.group ?? null;
        const list = stepGroups.get(key) ?? [];
        list.push({
            instruction: step.instruction,
            durationSeconds: step.durationSeconds,
            ingredientRefs: [],
        });
        stepGroups.set(key, list);
    }
    const labels = [
        ...draft.dietaryLabels.map((value) => ({
            kind: 'DIETARY',
            value,
            source: draft.origin === 'AI_GENERATED' ? 'AI' : 'IMPORT',
            confirmed: false,
        })),
        ...draft.allergens.map((value) => ({
            kind: 'ALLERGEN',
            value,
            source: draft.origin === 'AI_GENERATED' ? 'AI' : 'IMPORT',
            confirmed: false,
        })),
    ];
    return {
        title: draft.title,
        description: draft.description,
        servings: draft.servings ?? options.defaultServings ?? '4',
        servingsLabel: draft.servingsLabel,
        prepTimeMinutes: draft.prepTimeMinutes,
        cookTimeMinutes: draft.cookTimeMinutes,
        restTimeMinutes: draft.restTimeMinutes,
        difficulty: draft.difficulty,
        cuisine: draft.cuisine,
        mealType: draft.mealType,
        notes: draft.notes,
        status: 'DRAFT',
        visibility: 'PRIVATE',
        householdId: options.householdId ?? null,
        coverAssetId: draft.source?.copiedImageAssetId ?? null,
        galleryAssetIds: [],
        ingredientSections: [...ingredientGroups.entries()].map(([title, ingredients]) => ({
            title,
            ingredients,
        })),
        stepSections: [...stepGroups.entries()].map(([title, steps]) => ({ title, steps })),
        tags: [...new Set(draft.tags.map((t) => t.trim()).filter(Boolean))].slice(0, 50),
        categoryIds: [],
        labels,
    };
}
//# sourceMappingURL=draft-to-input.js.map